import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/header-logo.png";
import { Link, useSearchParams } from "react-router-dom";
import { getData } from "../../services/API";
import { toFarsiNumber } from "../../helper/helper";
import { useReactToPrint } from "react-to-print";

const PrintOrder = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);

  const printCom = useRef();

  const orderId = searchParams.get("orderId");
  const type = searchParams.get("type");

  useEffect(() => {
    const head = document.querySelector('meta[name="viewport"]');
    head.setAttribute("content", "width=1024");

    const body = document.querySelector("body");
    body.style.background = "#fff";

    getData(
      type === "website"
        ? `/shop/order/details-website/${orderId}`
        : `/shop/order/details/${orderId}`,
      {}
    )
      .then((res) => {
        setOrder(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setOrder(err.response.data.message);
      });
  }, []);

  const handlePrint = useReactToPrint({
    content: () => printCom.current,
  });

  return (
    <div className="w-full min-h-screen h-auto flex justify-center p-5 overflow-x-hidden">
      {loading ? (
        <span className="text-2xl font-black">لطفا صبر کنید...</span>
      ) : order === "Unauthenticated." ? (
        <div className="flex flex-col items-center justify-center gap-4">
          <span>لطفا ابتدا وارد حساب کاربری خود شوید</span>

          <Link
            to={"/auth"}
            className="py-3 px-5 bg-blue button-hover text-white rounded-xl"
          >
            ورود به حساب کاربری
          </Link>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <button
            onClick={handlePrint}
            className="py-2 px-4 text-lg rounded-xl bg-green-600 text-white font-extrabold"
          >
            چاپ فاکتور
          </button>

          {type === "website" ? (
            <div
              ref={printCom}
              className="w-full invoice-print max-w-[1024px] flex flex-col p-4 h-auto border border-gray-800"
            >
              {/* head */}
              <div className="grid grid-cols-3 gap-7">
                <div className="w-full text-2xl font-black flex justify-center items-center">
                  <span>صورت حساب کالا</span>
                </div>

                <div className="w-full flex flex-col gap-3 justify-center items-center">
                  <img src={logo} className="h-14" alt="" />

                  <span className="font-semibold text-gray-700">
                    خرید مطمئن از یونی بست
                  </span>

                  <div>
                    <span className="font-semibold">وبسایت: </span>
                    <span>www.myunibest.ir</span>
                  </div>
                </div>

                <div className="w-full flex flex-col gap-3 justify-center items-center">
                  <div>
                    <span className="font-semibold">تاریخ: </span>
                    <span>
                      {new Intl.DateTimeFormat("fa-IR", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      }).format(new Date(order?.created_at))}
                    </span>
                  </div>
                  <div>
                    <span className="font-semibold">شناسه سفارش: </span>
                    <span>{toFarsiNumber(String(order.id))}</span>
                  </div>
                  <div>
                    <span className="font-semibold">وضعیت سفارش: </span>
                    <span>
                      {order.status === 2
                        ? "پرداخت شده"
                        : order.status === 3
                        ? "ناموفق"
                        : order.status === 3
                        ? "ناموفق"
                        : order.status === 2
                        ? "پرداخت شده"
                        : order.status === 1
                        ? "درحال پرداخت"
                        : "در انتظار پرداخت"}
                    </span>
                  </div>
                </div>
              </div>

              {/* shop info */}
              <div className="w-full flex flex-col mt-6">
                <div className="border border-gray-800 py-3 text-center">
                  مشخصات فروشگاه
                </div>

                <div className="w-full text-[15px] flex flex-col gap-3 bg-gray-300 p-2 py-3 border border-gray-800 border-t-0">
                  {/* info 1 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">عنوان: </span>
                      <span>فروشگاه اینترنتی یونی بست</span>
                    </div>

                    <div>
                      <span className="font-bold">شماره ثبت/ملی: </span>
                      <span>{toFarsiNumber("14012082071")}</span>
                    </div>
                  </div>

                  {/* info 2 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">آدرس: </span>
                      <span>
                        میدان ونک، ابتدای حقانی، نرسیده به چهارراه جهان کودک،
                        <br /> پلاک ۴۰ مرکز نوآوری دانشگاه علامه طباطبایی طبقه
                        چهارم، یونی بست
                      </span>
                    </div>
                  </div>

                  {/* info 3 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">کد پستی: </span>
                      <span>{toFarsiNumber("1517974414")}</span>
                    </div>

                    <div>
                      <span className="font-bold">تلفن: </span>
                      <span>۰۲۱۹۱۶۹۰۹۲۳</span>
                    </div>

                    <div>
                      <span className="font-bold">ایمیل: </span>
                      <span>info@myunibest.ir</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* user info */}
              <div className="w-full flex flex-col">
                <div className="border border-gray-800 py-3 border-t-0 border-b-0 text-center">
                  مشخصات مشتری
                </div>

                <div className="w-full text-[15px] flex flex-col gap-3 bg-gray-300 p-2 py-3 border border-gray-800">
                  {/* info 1 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">نام و نام خانوادگی: </span>
                      <span>
                        {order?.user_info?.name +
                          " " +
                          order?.user_info?.family_name}
                      </span>
                    </div>

                    <div>
                      <span className="font-bold">شماره تلفن: </span>
                      <span>{toFarsiNumber(order.phone_number)}</span>
                    </div>

                    {order.email && (
                      <div>
                        <span className="font-bold">ایمیل: </span>
                        <span>{order.email}</span>
                      </div>
                    )}
                  </div>

                  {/* info 3 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-semibold">تاریخ: </span>
                      <span>
                        {new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        }).format(new Date(order?.created_at))}
                      </span>
                    </div>

                    <div>
                      <span className="font-bold">نوع پرداخت: </span>
                      <span>
                        {order?.transaction?.payment_method === "wallet"
                          ? "کیف پول"
                          : "درگاه پرداخت"}
                      </span>
                    </div>

                    {/* <div>
                    <span className="font-bold">روش حمل و نقل: </span>
                    <span>پست</span>
                  </div> */}
                  </div>
                </div>
              </div>

              {/* product info */}
              <div className="w-full flex flex-col">
                <div className="border border-gray-800 py-3 border-t-0 border-b-0 text-center">
                  شرح کالا
                </div>

                <div className="w-full text-[15px] grid grid-cols-12 bg-gray-300 h-[48px] border border-gray-800">
                  <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                    #
                  </div>
                  <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                    شناسه
                  </div>
                  <div className="font-bold col-span-5 border-l border-gray-800 flex items-center justify-center px-3">
                    پکیج
                  </div>
                  <div className="font-bold col-span-5 border-gray-800 flex items-center justify-center px-3">
                    پلن پشتیبانی
                  </div>
                </div>

                {/* products list */}
                {order.info.map((product) => (
                  <div className="w-full text-[15px] grid grid-cols-12 h-[48px] border border-gray-800 border-t-0">
                    <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                      {toFarsiNumber(order.info.length)}
                    </div>
                    <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                      {toFarsiNumber(product.id)}
                    </div>
                    <div className="col-span-5 border-l text-sm border-gray-800 flex items-center justify-center px-3">
                      {`وبسایت ${order?.product?.type?.name} - پکیج ${order?.product?.name}`}
                    </div>
                    <div className="col-span-5 border-gray-800 flex items-center justify-center gap-1">
                      {order?.support?.name}
                    </div>
                  </div>
                ))}
              </div>

              {/* prices */}
              <div className="w-full flex flex-col mt-4">
                <div className="grid grid-cols-2 border border-b-0 border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مبلغ پکیج</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(order.cost)}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 border border-b-0 border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مبلغ پشتیبانی</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(order.support_cost)}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 border border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مالیات</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(Number(order.tax))}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                {/* discount */}
                <div className="grid grid-cols-2 border border-gray-800 border-t-0 p-3">
                  <div>
                    <span className="font-bold">مبلغ تخفیف</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(order.discount)}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                {/* all cost with tax */}
                <div className="grid grid-cols-2 border border-t-0 border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مبلغ کل سفارش</span>
                    <span className="text-xs">(با احتساب مالیات و تخفیف)</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(
                        order.cost +
                          order.support_cost +
                          Number(order.tax) -
                          Number(order.discount || 0)
                      )}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                {/* delivery cost */}
                {/* <div className="grid grid-cols-2 border border-gray-800 border-t-0 p-3">
                <div>
                  <span className="font-bold">مبلغ حمل و نقل</span>
                </div>

                <div className="flex items-center gap-1">
                  <span className="font-semibold text-lg">
                    {toFarsiNumber(55000)}
                  </span>
                  <span className="text-sm">تومان</span>
                </div>
              </div> */}

                {/* final cost */}
                {/* <div className="grid grid-cols-2 border border-gray-800 border-t-0 p-3">
                <div>
                  <span className="font-bold">مبلغ نهایی</span>
                </div>

                <div className="flex items-center gap-1">
                  <span className="font-semibold text-lg">
                    {toFarsiNumber(55000)}
                  </span>
                  <span className="text-sm">تومان</span>
                </div>
              </div> */}

                {/* final cost */}
                <div className="flex border border-gray-800 border-t-0 p-3">
                  <p className="text-gray-800 text-sm">
                    <span className="font-bold text-base text-black">
                      یادداشت مشتری:{" "}
                    </span>
                    {order.description
                      ? order.description
                      : "یادداشتی وجود ندارد !"}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              ref={printCom}
              className="w-full invoice-print max-w-[1024px] flex flex-col p-4 h-auto border border-gray-800"
            >
              {/* head */}
              <div className="grid grid-cols-3 gap-7">
                <div className="w-full text-2xl font-black flex justify-center items-center">
                  <span>صورت حساب کالا</span>
                </div>

                <div className="w-full flex flex-col gap-3 justify-center items-center">
                  <img src={logo} className="h-14" alt="" />

                  <span className="font-semibold text-gray-700">
                    خرید مطمئن از یونی بست
                  </span>

                  <div>
                    <span className="font-semibold">وبسایت: </span>
                    <span>www.myunibest.ir</span>
                  </div>
                </div>

                <div className="w-full flex flex-col gap-3 justify-center items-center">
                  <div>
                    <span className="font-semibold">تاریخ: </span>
                    <span>
                      {new Intl.DateTimeFormat("fa-IR", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      }).format(new Date(order?.created_at))}
                    </span>
                  </div>
                  <div>
                    <span className="font-semibold">شناسه سفارش: </span>
                    <span>{toFarsiNumber(String(order.id))}</span>
                  </div>
                  <div>
                    <span className="font-semibold">وضعیت سفارش: </span>
                    <span>
                      {order.status === "done"
                        ? "تکمیل شده"
                        : order.status === "canceled"
                        ? "لغو شده"
                        : order.status === "failed"
                        ? "ناموفق"
                        : order.status === "paid"
                        ? "پرداخت شده"
                        : order.status === "paying"
                        ? "درحال پرداخت"
                        : "در انتظار پرداخت"}
                    </span>
                  </div>
                </div>
              </div>

              {/* shop info */}
              <div className="w-full flex flex-col mt-6">
                <div className="border border-gray-800 py-3 text-center">
                  مشخصات فروشگاه
                </div>

                <div className="w-full text-[15px] flex flex-col gap-3 bg-gray-300 p-2 py-3 border border-gray-800 border-t-0">
                  {/* info 1 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">عنوان: </span>
                      <span>فروشگاه اینترنتی یونی بست</span>
                    </div>

                    <div>
                      <span className="font-bold">شماره ثبت/ملی: </span>
                      <span>{toFarsiNumber("14012082071")}</span>
                    </div>
                  </div>

                  {/* info 2 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">آدرس: </span>
                      <span>
                        میدان ونک، ابتدای حقانی، نرسیده به چهارراه جهان کودک،
                        <br /> پلاک ۴۰ مرکز نوآوری دانشگاه علامه طباطبایی طبقه
                        چهارم، یونی بست
                      </span>
                    </div>
                  </div>

                  {/* info 3 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">کد پستی: </span>
                      <span>{toFarsiNumber("1517974414")}</span>
                    </div>

                    <div>
                      <span className="font-bold">تلفن: </span>
                      <span>۰۲۱۹۱۶۹۰۹۲۳</span>
                    </div>

                    <div>
                      <span className="font-bold">ایمیل: </span>
                      <span>info@myunibest.ir</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* user info */}
              <div className="w-full flex flex-col">
                <div className="border border-gray-800 py-3 border-t-0 border-b-0 text-center">
                  مشخصات مشتری
                </div>

                <div className="w-full text-[15px] flex flex-col gap-3 bg-gray-300 p-2 py-3 border border-gray-800">
                  {/* info 1 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-bold">نام و نام خانوادگی: </span>
                      <span>
                        {order?.user_info?.name +
                          " " +
                          order?.user_info?.family_name}
                      </span>
                    </div>

                    <div>
                      <span className="font-bold">شماره تلفن: </span>
                      <span>{toFarsiNumber(order.phone_number)}</span>
                    </div>

                    {order.email && (
                      <div>
                        <span className="font-bold">ایمیل: </span>
                        <span>{order.email}</span>
                      </div>
                    )}
                  </div>

                  {/* info 3 */}
                  <div className="flex items-center gap-6">
                    <div>
                      <span className="font-semibold">تاریخ: </span>
                      <span>
                        {new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        }).format(new Date(order?.created_at))}
                      </span>
                    </div>

                    <div>
                      <span className="font-bold">روش پرداخت: </span>
                      <span>پرداخت آنلاین</span>
                    </div>

                    {/* <div>
                    <span className="font-bold">روش حمل و نقل: </span>
                    <span>پست</span>
                  </div> */}
                  </div>
                </div>
              </div>

              {/* product info */}
              <div className="w-full flex flex-col">
                <div className="border border-gray-800 py-3 border-t-0 border-b-0 text-center">
                  شرح کالا
                </div>

                <div className="w-full text-[15px] grid grid-cols-12 bg-gray-300 h-[48px] border border-gray-800">
                  <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                    #
                  </div>
                  <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                    شناسه
                  </div>
                  <div className="font-bold col-span-4 border-l border-gray-800 flex items-center justify-center px-3">
                    محصول
                  </div>
                  <div className="font-bold border-l col-span-2 border-gray-800 flex items-center justify-center px-3">
                    قیمت
                  </div>
                  <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                    تعداد
                  </div>
                  <div className="font-bold col-span-3 border-gray-800 flex items-center justify-center">
                    قیمت کل
                  </div>
                  {/* <div className="font-bold col-span-2 flex justify-center items-center">
                  کل + مالیات
                </div> */}
                </div>

                {/* products list */}
                {order.info.map((product) => (
                  <div className="w-full text-[15px] grid grid-cols-12 h-[48px] border border-gray-800 border-t-0">
                    <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                      {toFarsiNumber(order.info.length)}
                    </div>
                    <div className="font-bold border-l border-gray-800 flex items-center justify-center">
                      {toFarsiNumber(product.id)}
                    </div>
                    <div className="col-span-4 border-l text-sm border-gray-800 flex items-center justify-center px-3">
                      {product.title}
                    </div>
                    <div className="border-l col-span-2 border-gray-800 flex items-center justify-center gap-1">
                      <span>{toFarsiNumber(Number(product.bought_price))}</span>
                      <span className="text-xs">تومان</span>
                    </div>
                    <div className="border-l border-gray-800 flex items-center justify-center">
                      {toFarsiNumber(product.user_qty)}
                    </div>
                    <div className="col-span-3 border-gray-800 flex items-center justify-center gap-1">
                      <span>{toFarsiNumber(Number(product.bought_price))}</span>
                      <span className="text-xs">تومان</span>
                    </div>
                    {/* <div className="flex col-span-2 justify-center items-center gap-1">
                    <span>{toFarsiNumber(Number(order.cost))}</span>
                    <span className="text-xs">تومان</span>
                  </div> */}
                  </div>
                ))}
              </div>

              {/* prices */}
              <div className="w-full flex flex-col mt-4">
                <div className="grid grid-cols-2 border border-b-0 border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مبلغ کل پکیج ها</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(order.cost)}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 border border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مالیات</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(Number(order.tax))}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                {/* discount */}
                <div className="grid grid-cols-2 border border-gray-800 border-t-0 p-3">
                  <div>
                    <span className="font-bold">مبلغ تخفیف</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(order.discount)}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                {/* all cost with tax */}
                <div className="grid grid-cols-2 border border-t-0 border-gray-800 p-3">
                  <div>
                    <span className="font-bold">مبلغ کل سفارش</span>
                    <span className="text-xs">(با احتساب مالیات و تخفیف)</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <span className="font-semibold text-lg">
                      {toFarsiNumber(
                        Number(order.cost) +
                          Number(order.tax) -
                          Number(order.discount)
                      )}
                    </span>
                    <span className="text-sm">تومان</span>
                  </div>
                </div>

                {/* delivery cost */}
                {/* <div className="grid grid-cols-2 border border-gray-800 border-t-0 p-3">
                <div>
                  <span className="font-bold">مبلغ حمل و نقل</span>
                </div>

                <div className="flex items-center gap-1">
                  <span className="font-semibold text-lg">
                    {toFarsiNumber(55000)}
                  </span>
                  <span className="text-sm">تومان</span>
                </div>
              </div> */}

                {/* final cost */}
                {/* <div className="grid grid-cols-2 border border-gray-800 border-t-0 p-3">
                <div>
                  <span className="font-bold">مبلغ نهایی</span>
                </div>

                <div className="flex items-center gap-1">
                  <span className="font-semibold text-lg">
                    {toFarsiNumber(55000)}
                  </span>
                  <span className="text-sm">تومان</span>
                </div>
              </div> */}

                {/* final cost */}
                <div className="flex border border-gray-800 border-t-0 p-3">
                  <p className="text-gray-800 text-sm">
                    <span className="font-bold text-base text-black">
                      یادداشت مشتری:{" "}
                    </span>
                    {order.description
                      ? order.description
                      : "یادداشتی وجود ندارد !"}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PrintOrder;
